import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getvendorvacs: option =>
    request('v1/vacorder/getvendorvacs', option, true, false), // 查询企业增值业务订购列表
  getvacorders: option =>
    request('v1/vacorder/getvacorders', option, true, false), // 查询增值业务订购列表
  getorderablevacs: option =>
    request('v1/vacorder/getorderablevacs', option, true, false), // 查询可订购增值业务列表
  addvacorder: option =>
    request('v1/vacorder/addvacorder', option, true, false), // 订购增值业务
  trialvacorder: option =>
    request('v1/vacorder/trialvacorder', option, true, false), // 试用增值业务
  extendvacorder: option =>
    request('v1/vacorder/extendvacorder', option, true, false), // 延长增值业务（正式使用）
  deletevacorder: option => {
    const urls = querystring(option)
    return request('v1/vacorder/deletevacorder' + urls, option, true, false) // 删除增值业务订购,
  },
  stopvacorder: option =>
    request('v1/vacorder/stopvacorder', option, true, false), // 停用增值业务
  resumevacorder: option =>
    request('v1/vacorder/resumevacorder', option, true, false), // 启用增值业务
  getvacorder: option => {
    const urls = querystring(option)
    return request('v1/vacorder/getvacorder' + urls, {}, true, false) //  查询增值业务订购
  }
}
